var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackArrowCircled = function SvgBackArrowCircled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4226 16.0774C16.748 16.4029 16.748 16.9305 16.4226 17.2559L14.5118 19.1667H27.5C27.9602 19.1667 28.3333 19.5398 28.3333 20C28.3333 20.4602 27.9602 20.8333 27.5 20.8333H14.5118L16.4226 22.7441C16.748 23.0695 16.748 23.5972 16.4226 23.9226C16.0972 24.248 15.5695 24.248 15.2441 23.9226L11.9111 20.5896C11.911 20.5895 11.9109 20.5894 11.9107 20.5893C11.9102 20.5887 11.9096 20.5881 11.909 20.5875C11.83 20.508 11.7703 20.4166 11.7299 20.319C11.6892 20.2207 11.6667 20.113 11.6667 20C11.6667 19.887 11.6892 19.7793 11.7299 19.681C11.7706 19.5827 11.8309 19.4906 11.9107 19.4107L15.2441 16.0774C15.5695 15.752 16.0972 15.752 16.4226 16.0774Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrowCircled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "BackArrowCircled.9c81713a94191c6f224a90e2deb02a1a.svg";